import { __awaiter, __generator } from "tslib";
import { DataSyncModeEnum, FbClientBuilder, UserBuilder } from '@featbit/js-client-sdk';
import { Fetch, Resource } from '@ekuaibao/fetch';
var featBitApi = new Resource('/api/v2/environment/featbit');
var fbClient;
export var initFeatBit = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data, staffId, ekbCorpId, user, config, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4, featBitApi.GET('')];
            case 1:
                data = _a.sent();
                staffId = Fetch.staffId;
                ekbCorpId = Fetch.ekbCorpId;
                if (!ekbCorpId) {
                    return [2];
                }
                user = new UserBuilder(staffId)
                    .custom('corpId', ekbCorpId)
                    .build();
                config = data.value;
                fbClient = new FbClientBuilder()
                    .sdkKey(config.clientKey)
                    .pollingUri(config.eventUrl)
                    .eventsUri(config.openapiUrl)
                    .dataSyncMode(DataSyncModeEnum.POLLING)
                    .pollingInterval(60000)
                    .user(user)
                    .build()
                    .addListener('error', function (error) {
                    console.log(error);
                });
                return [4, fbClient.waitForInitialization()];
            case 2:
                _a.sent();
                return [3, 4];
            case 3:
                e_1 = _a.sent();
                console.log(e_1);
                return [3, 4];
            case 4: return [2];
        }
    });
}); };
export var getVariation = function (flagKey, defaultValue) {
    return (fbClient === null || fbClient === void 0 ? void 0 : fbClient.variation(flagKey, defaultValue)) || defaultValue;
};
export var getBoolVariation = function (flagKey, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    return (fbClient === null || fbClient === void 0 ? void 0 : fbClient.boolVariation(flagKey, defaultValue)) || defaultValue;
};
